import clsx from 'clsx'

import { LinkButton } from '@/components/core-v2'

import { useOrdersFiltersContext } from '../assets-filter-list/orders-filter-context'
import classes from './orders-header.module.scss'
import { isMutualFund } from './orders-types'

export interface OrdersHeaderProps {
  showModal: () => void
}

export const OrdersHeader = ({ showModal }: OrdersHeaderProps) => {
  const { asset } = useOrdersFiltersContext()
  const type = asset.type === 'MutualFund' ? 'Mutual fund' : 'Segregated portfolio'
  return (
    <div className={clsx(classes.root, 'ml-6')}>
      <div>
        <span className={classes.assetNameHeading}>
          <strong>{asset.name}</strong>
          <LinkButton underline onClick={() => showModal()}>
            View details
          </LinkButton>
        </span>
      </div>
      <div>
        <span className={classes.detail}>
          <span className={classes.heading}>Type: </span>
          <strong>{type}</strong>
        </span>
        {isMutualFund(asset) && (
          <>
            <span className={classes.detail}>
              <span className={classes.heading}>Fund manager: </span>
              <strong data-private>{asset.externalIdentifiers.managementCompanyCode}</strong>
            </span>
            <span className={classes.detail}>
              <span className={classes.heading}>Finswitch fund code: </span>
              <strong>{asset.externalIdentifiers.fundCode}</strong>
            </span>
          </>
        )}
      </div>
    </div>
  )
}
